<template>
  <div>  
    <user-header></user-header>
    <div class="overflow-hidden">
      <transition class="overflow-hidden" enter-active-class="animate__animated animate__fadeInUp " leave-active-class="animate__animated animate__fadeOutUp animate__faster">
        <router-view></router-view>
      </transition>
    </div>
    <user-footer></user-footer>
  </div>
</template>

<script>
import UserHeader from '../components/UserHeader.vue';
import UserFooter from '../components/UserFooter.vue';

export default {
  components: {
    UserHeader,
    UserFooter,
  },
  name: 'Userpage',
  data(){
    return{
      coreVirtues: "áptitude brings you all the added sporting values ​​you can find, without any constraints. Benefit from an online coach, evolving statistics, personalized programs, free sessions, follow-up planning, photo evolution, medium and long-term BMI evolution, in short, real personalized support in according to your needs..",
      subscriptions: "Our tailor-made subscriptions just for you."    
    }
  },
  methods:{
    selectComponent(component){
      this.selectedComponent = component
    },
  },


}
</script>
